import {message, Button, Col, Form, Row} from "antd";
import React, {useEffect, useState} from "react";
import api from "../../api";
import {useNavigate, useParams} from "react-router-dom";
import TextArea from "antd/lib/input/TextArea";
import OrderOverview from "../../Components/OrderOverview";
import {ArrowLeftOutlined, ArrowUpOutlined, CopyOutlined} from "@ant-design/icons";
import {DEFAULT_GUTTER} from "../../constants";
export default function UserOrderStatus() {
    const {order_id, secret} = useParams();
    const [order, setOrder] = useState(null);
    const [form] = Form.useForm();
    const navigate = useNavigate();

    useEffect(() => {
        api.getOrder(order_id, secret).then(setOrder)
    }, []);

    const copyOrderUrl = () => {
        const url = window.location.href;
        navigator.clipboard.writeText(`https://oogst.app/customer/order/status/${order_id}/${secret}`);
        message.success('Bestel-URL gekopieerd naar klembord!');
    };


    function markAsHandled() {
        api.updateOrderStatus(order.id, 'handled').then(() => {
            message.success("Order is gemarkeerd als afgehandeld!");
        })
    }

    function cancelOrder() {
        api.updateOrderStatus(order.id, 'cancelled').then(() => {
            message.success("Order is geannuleerd!");
            navigate('/orders');
        })
    }

    return (
        <>
            <Row className={"mar-t-1 mar-b-1"}>
                <Col md={12} xs={24} sm={24}>
                    <Button type={"link"} onClick={() => navigate('/orders')}>
                        <ArrowLeftOutlined/> Terug naar bestellingen
                    </Button>
                </Col>
                <Col md={12} xs={24} sm={24} className={"text-right"}>

                        <Button
                            icon={<CopyOutlined />}
                            onClick={copyOrderUrl}
                        >
                            Kopieer Bestel-URL
                        </Button>

                    <Button className={"mar-l-1"} type={"primary"} onClick={() => markAsHandled()}>Markeer als afgehandeld</Button>
                    <Button onClick={() => cancelOrder()} danger className={"mar-l-1"}>Order annuleren</Button>
                </Col>
            </Row>

            <OrderOverview order={order} isSeller={true}/>

            {order && (

                <Form layout={"vertical"} form={form}>
                    <Row gutter={DEFAULT_GUTTER}>
                        <Col span={24}>
                            <Form.Item label={"Stuur bericht naar de koper"} name={"message"}>
                                <TextArea/>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item>
                                <Button type={"primary"} onClick={() => {
                                    if (form.getFieldValue('message') === "") {
                                        return
                                    }
                                    api.messageBuyer(order.id, order.secret, form.getFieldValue('message')).then(() => {
                                        message.success("Bericht is verstuurd naar koper!");
                                        form.resetFields();
                                        api.getOrder(order_id, secret).then(setOrder)
                                    }).catch(() => {
                                        message.error("Er is een fout opgetreden bij het versturen van het bericht.");
                                    });
                                }}><ArrowUpOutlined/> Verstuur</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            )}


        </>
    );
}